export interface Card {
  id: number;
  difficulty: number;
  question: string;
  answer: string;
  category: string;
  questionImage: boolean;
  answerImage: boolean;
}

export interface CardPublished extends Card {
  group: number;
  publishedAt: Date;
  new?: boolean;
}

export class Card implements Card {
}





// WEBPACK FOOTER //
// ./src/app/shared/models/card.model.ts